import React from 'react';
import '../root.css';
import '../css/FindmefontPage.css';
import SEO from '../components/SEO';

function FindmefontPage() {
  return (
    <>
      <SEO
        title="FindMeFont - AI Font Discovery SaaS | Samuel Banczík"
        description="FindMeFont is an AI-driven B2C SaaS platform founded by Samuel Banczík that helps creators find the right font in seconds by matching the intent behind their text with the perfect typography."
        keywords="FindMeFont, font finder, AI typography, font discovery, web fonts, typography SaaS, Samuel Banczík"
        url="https://banczik.com/findmefont"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "FindMeFont",
          // The entity lives on its own domain; this page only describes it.
          "url": "https://findmefont.banczik.com",
          "sameAs": "https://findmefont.banczik.com",
          "mainEntityOfPage": "https://banczik.com/findmefont",
          "applicationCategory": "DesignApplication",
          "operatingSystem": "Web",
          "author": {
            "@type": "Person",
            "name": "Samuel Banczík",
            "url": "https://banczik.com"
          },
          "description": "AI font discovery platform that matches the intent behind a text with the right typography",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
              { "@type": "ListItem", "position": 2, "name": "FindMeFont", "item": "https://banczik.com/findmefont" }
            ]
          }
        }}
      />
      <div>FindmefontPage</div>
    </>
  )
}

export default FindmefontPage